export enum EnumEstadoFichero {
  Esperando = 1,
  EnProceso = 2,
  Error = 3, // Reemplaza FinalizadoKO
  FinalizadoKO = 3,
  Finalizado = 4, // Reemplaza FinalidoOK
  FinalidoOK = 4,
  StorageException = 5,
  Aviso = 6, // Reemplaza FinalizadoAviso
  FinalizadoAviso = 6,
  FinalizadoBAD = 7
}
